import {AppNotificationMessage} from "../../domain/model/app_notification_message";

interface IAddAppNotificationResponse {
    appNotificationMessage: AppNotificationMessage;
}
class AddAppNotificationResponse implements IAddAppNotificationResponse {
    public appNotificationMessage: AppNotificationMessage;
}

interface IHiddenAppNotificationResponse {
    appNotificationMessages: AppNotificationMessage[],
}
class HiddenAppNotificationResponse implements IHiddenAppNotificationResponse {
    public appNotificationMessages: AppNotificationMessage[];
}

export {
    AddAppNotificationResponse,
    HiddenAppNotificationResponse,
}



// WEBPACK FOOTER //
// ./src/presentation/response/app_notification_message_response.ts